import { Button, CloseButton } from '@ui/shared/Button';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import styled from 'styled-components';
import { closePopup, openPopup } from '../../../data/providers/popupsProvider';
import { Entity, IRange, Level } from '../../../data/types';
import { Column } from '../../../ui/layout/Column';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../shared/card/CardHeader';
import { InnerPopupCard } from '../../shared/popups/PopupCard';
import { BlockTrendGraph } from './BlockTrendGraph';

interface IPopupProps {
  level: Level;
  onClose: () => void;
  range: IRange;
  queryHash: string;
  entityId: string;
  entity: Entity;
  metricKey: string;
  metricName: string;
}

export const PopupContent = (props: IPopupProps): React.ReactElement => {
  const Wrapper = props.level === 2 ? Card : InnerPopupCard;

  return (
    <Wrapper onClose={props.onClose} size='medium' noClickOutside>
      <Column>
        <CardHeader surface={8}>
          <CardHeaderLeft>
            <h6>Metric History - {props.metricName}</h6>
          </CardHeaderLeft>
          <CardHeaderRight>
            <CloseButton onClick={props.onClose} />
          </CardHeaderRight>
        </CardHeader>
        <CardBody>
          <BlockTrendGraph
            entity={props.entity}
            metricKey={props.metricKey}
            metricName={props.metricName}
            range={props.range}
            queryHash={props.queryHash}
            entityId={props.entityId}
          />
        </CardBody>
      </Column>
    </Wrapper>
  );
};

interface IBlockTrendTriggerProps extends RouteComponentProps {
  entity: Entity;
  entityId: string;
  metricKey: string;
  metricName: string;
  queryHash: string;
  range: IRange;
  children: React.ReactNode;
}

/**
 * Wraps children with click handler to open the trend popup
 */
export const BlockTrendTrigger = withRouter(
  (props: IBlockTrendTriggerProps): React.ReactElement => {
    const open = (): void =>
      openPopup(
        <PopupContent
          entity={props.entity}
          metricKey={props.metricKey}
          metricName={props.metricName}
          level={1}
          onClose={closePopup(props.history)}
          queryHash={props.queryHash}
          entityId={props.entityId}
          range={props.range}
        />,
        props.history,
        'metric-history-popup'
      );

    return (
      <TriggerWrapper
        onClick={(e: React.MouseEvent): void => {
          e.preventDefault();
          e.stopPropagation();
          open();
        }}
      >
        {props.children}
      </TriggerWrapper>
    );
  }
);

const TriggerWrapper = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
